function formatCustomDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`; // Example: YYYY-MM-DD
}

const downloadFile = ({ data, fileName, fileType }) => {
    // Create a blob with the data we want to download as a file
    const blob = new Blob([data], { type: fileType });
    // Create an anchor element and dispatch a click event on it
    // to trigger a download
    const a = document.createElement('a');
    a.download = fileName;
    a.href = window.URL.createObjectURL(blob);
    const clickEvt = new MouseEvent('click', {
        view: window,
        bubbles: true,
        cancelable: true,
    });
    a.dispatchEvent(clickEvt);
    a.remove();
};

const exportToCsv = ({ items, headers, fileNamePrefix, delimiter = ',' }) => {
    // Convert users data to a csv
    let csvData = items.reduce((acc, item) => {
        let line = headers.map((header) => `"${item[header]?.replace?.(/"/g, '""') || JSON.stringify(item[header])}"`).join(delimiter);
        acc.push(`${line}`);
        return acc;
    }, []);

    let sanitizedHeaders = [headers.join(delimiter)];

    downloadFile({
        data: [...sanitizedHeaders, ...csvData].join('\n'),
        fileName: `${fileNamePrefix}-${formatCustomDate(new Date())}.csv`,
        fileType: 'text/csv',
    });
};

export {
    formatCustomDate,
    downloadFile,
    exportToCsv,
}
